'use strict';

import * as util from '../util/Common.js';
import {DataTypes} from '../viewer/DomItem.js';
import {JsonLdUtil} from '../viewer/JsonLdManifestLoader.js';

const privateMap = util.createPrivateMapper();

export const IIIFv3Util = {
  getLink: function(vs) {
    const ret = [];
    const l = vs.length;
    for (let i = 0; i < l; i++) {
      const v = vs[i];
      let url;
      let label;
      if (typeof(v) == 'string') {
        url = v;
        label = v;
      } else if (v['id']) {
        url = v['id'];
        label = v['label'] ? v['label'] : url;
      }
      if (!url) {
        continue;
      }
      ret[ret.length] = {
        type: DataTypes.Link,
        label: label,
        format: v['format'],
        url: url
      };
    }
    if (!ret.length) {
      return null;
    }
    return ret;
  },
  getImage: function(vs) {
    const ret = [];
    const l = vs.length;
    for (let i = 0; i < l; i++) {
      const v = vs[i];
      if (typeof(v) == 'string') {
        ret[ret.length] = {
          type: DataTypes.Image,
          src: v
        };
      }
    }
    if (!ret.length) {
      return null;
    }
    return ret;
  },
  getText: function(vs) {
    const l = vs.length;
    const langs = {};
    let hasValue = false;
    for (let i = 0; i < l; i++) {
      const v = vs[i];
      if (typeof(v) == 'string') {
        let dvs = langs['@none'];
        if (!dvs) {
          dvs = [];
          langs['@none'] = dvs;
        }
        dvs[dvs.length] = v;
      } else if (v['@none']) {
        for (let ln in v) {
          let vs = langs[ln];
          if (!vs) {
            vs = [];
            langs[ln] = vs;
          }
          const lv = v[ln];
          if (util.isArray(lv)) {
            const vl = lv.length;
            for (let vi = 0; vi < vl; vi++) {
              vs[vs.length] = lv[vi];
            }
          } else if (typeof(lv) == 'string') {
            vs[vs.length] = v[ln];
          }
        }
      }
      hasValue = true;
    }
    if (!hasValue) {
      return null;
    }
    return {
      type: DataTypes.Text,
      text: langs
    };
  },
  getData: function(vs, valueType) {
    if (!vs || !vs.length) {
      return;
    }
    let data;
    switch (valueType) {
    case DataTypes.Text:
      data = this.getText(vs);
      break;
    case DataTypes.Image:
      data = this.getImage(vs);
      break;
    case DataTypes.Link:
      data = this.getLink(vs);
      break;
    }
    return data;
  },

  extractAttributes: function(node, json){
    const f = (fname, valueType) => {
      const data = this.getData(JsonLdUtil.getLdField(json, fname), valueType);
      if (!data) {
        return;
      }
      node[fname] = data;
    }
    f('label', DataTypes.Text);
    f('description', DataTypes.Text);
    f('attribution', DataTypes.Text);
    f('license', DataTypes.Text);
    f('logo', DataTypes.Image);

    node.metadata = [];
    if (json.metadata) {
      const l = json.metadata.length;
      for (let i = 0; i < l; i++) {
        const meta = json.metadata[i];
        const data = this.getData(JsonLdUtil.getLdField(meta, 'value'), DataTypes.Text);
        if (!data) {
          continue;
        }
        const label = this.getData(JsonLdUtil.getLdField(meta, 'label'), DataTypes.Text);
        node.metadata[node.metadata.length] = {
          label: label,
          value: data
        };
      }
    }
    f('collections', DataTypes.Link);
    f('related', DataTypes.Link);
    f('seeAlso', DataTypes.Link);
    f('rendering', DataTypes.Link);
  }
}

export class IIIFv3Analyzer {
  constructor(options){
    const pv = privateMap(this);
    pv.targetContexts = {
      'http://iiif.io/api/presentation/3/context.json': true
    };
  }

  isTarget(json){
    const pv = privateMap(this);
    const contexts = JsonLdUtil.getLdField(json, '@context');
    return (json.id && json.type) || JsonLdUtil.checkContext(contexts, pv.targetContexts);
  }

  createItem(json) {
    const id = json['id'];
    const body = json['body'];
    const source = {
      'id': body['id'],
      'type': body['type'],
      'format': body['format']
    }
    return source;
  }

  convertItems(base, scenes, items, node){
    if (!items) {
      return;
    }
    const l = items.length;
    for (let i = 0; i < l; i++) {
      const item = items[i];
      let nd = node;
      if (item['type'] == 'Canvas') {
        console.log(item);
        if (!nd) {
          nd = {};
        }
        IIIFv3Util.extractAttributes(nd, item);
      }

      if (item['motivation'] != 'painting') {
        this.convertItems(base, scenes, item.items, nd);
        continue;
      }
      const id = item['id'];
      const body = item['body'];
      if (!id || !body) {
        continue;
      }
      const source = this.createItem(item);
      const scene = {
        source: source
      };
      // scene.type = formatMap[scene.format];
      // scene.type = 'three';
      if (nd) {
        for (let k in nd) {
          scenes[k] = nd[k];
        }
      }
      scenes.push(scene);
    }
  }

  createScene(json) {
    const scene = {};
    const source = {};
    scene.source = source;
    scene.id = json['id'];

    source.items = [];
    util.each(json.content, (c) => {
      util.each(c.items, (itemJson) => {
        const item = this.createItem(itemJson);
        console.log(item);
        if (!item) {
          return;
        }
        source.items.push(item);
      });
    });

    IIIFv3Util.extractAttributes(scene, json);
    source.width = json.width;
    source.height = json.height;
    return scene;
  }

  createSequence(json){
    const sequence = {
      viewTypes: ['default'],
      scenes: []
    };
    sequence.id = json['id'];

    IIIFv3Util.extractAttributes(sequence, json);

    // sequence.label = json.label;
    util.each(json.canvases, (canvasJson) => {
      const scene = this.createScene(canvasJson);
      if (!scene) {
        return;
      }
      sequence.scenes.push(scene);
    });
    return sequence;
  }

  analyze(json, manifest){
    // const formatMap = options.formatMap ? options.formatMap : {};


    manifest.id = json.id;
    if (json.items) {
      const scenes = [];
      this.convertItems(manifest, scenes, json.items, {});
      if (scenes.length) {
        manifest.sequences.push({
          viewTypes: ['default'],
          scenes: scenes
        });
      }
    } else if (json.sequences) {
      json.sequences.forEach(sequenceJson => {
        const sequence = this.createSequence(sequenceJson);
        if (!sequence) {
          return;
        }
        manifest.sequences.push(sequence);
      })
    }
    if (json.thumbnail) {
      // m.createThumbnail = function(contEl, size, emptyFunc) {
      //   return createThumbnail(contEl, new Point2D(size), json, emptyFunc);
      // };
    }
    IIIFv3Util.extractAttributes(manifest.metadata, json);
  }

  analyzeAnnotationList(json, res){
  }
}
